import {connect} from 'react-redux'
import * as loginActions from '../../store/login/actions'
import LoginForm from '../../components/forms/login-form'

function mapStateToProps (state) {
  return {
    isAuthenticated: state.login.isAuthenticated,
    isLoading: state.login.isLoading,
    authError: state.login.authError,
    isTokenExpired: state.login.isTokenExpired,
  }
}

export default connect(mapStateToProps, loginActions)(LoginForm)



// WEBPACK FOOTER //
// ./src/containers/login/login-form-container.js